import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { reduxForm, formValueSelector, change } from 'redux-form';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';

import SubCategoryItem from './SubCategoryItem';
import PricingDetails from './PricingDetails';

import { isRTL } from '../../../../helpers/formatLocale';
import nextIcon from '/public/Icons/sliderNextIcon.svg';
import prevIcon from '/public/Icons/sliderPrevIcon.svg';
import PreferredProviders from './PreferredProviders';
import cs from 'swiper/swiper-bundle.css';
import s from '../../../../styles/customSwiper.css'


const ArrowButton = ({ className, icon, alt }) => (
    <div className={className}>
        <img src={icon} alt={alt} className='subCategorySliderArrowBtnImg' />
    </div>
);

class SubCategorySlider extends React.Component {

    static defaultProps = {
        data: [],
    };

    constructor(props) {
        super(props);
        this.state = {
            load: false,
            orders: [],
            loader: false
        };
        if (typeof window !== 'undefined') {
            this.swiperPackage = require('swiper/react');
            this.swiperModulesPackage = require('swiper/modules');

        }
    }

    componentDidMount() {
        this.setState({ load: true });
    }

    componentDidUpdate(prevProps) {
        const { locale } = this.props.intl;
        const { locale: prevLocale } = prevProps.intl;

        if (locale !== prevLocale) {
            this.setState({ load: false });
            clearTimeout(this.loadSync);
            this.loadSync = null;
            this.loadSync = setTimeout(() => {
                this.setState({ load: true })
            }, 1);
        }
    }

    handleAddOrder = async (data) => {
        const { orders } = this.state;
        const { change } = this.props;
        this.setState({ loader: true });
        let addOrders = orders;
        addOrders.push(data);
        this.setState({ orders: addOrders });
        await change('orderData', addOrders);
        this.setState({ loader: false });
    }

    handleRemoveOrder = async (id) => {
        const { orders } = this.state
        const { change } = this.props;
        this.setState({ loader: true });
        let existsOrder = orders.filter((o) => o.subCategoryId !== id);
        this.setState({ orders: existsOrder });
        await change('orderData', existsOrder);
        this.setState({ loader: false });
    }

    addOrderQuantity = async (data) => {
        const { orders } = this.state
        const { change } = this.props;
        this.setState({ loader: true });
        let ordersData = orders
        for (let obj of ordersData) {
            if (obj.subCategoryId == data.id) {
                obj.quantity += 1
            }
        }
        this.setState({ orders: ordersData });
        await change('orderData', ordersData);
        this.setState({ loader: false });
    }

    removeOrderQuantity = async (data) => {
        const { orders } = this.state
        const { change } = this.props;
        this.setState({ loader: true });
        let ordersData = orders
        for (let obj of ordersData) {
            if (obj.subCategoryId == data.id) {
                obj.quantity -= 1
            }
        }
        this.setState({ orders: ordersData });
        await change('orderData', ordersData);
        this.setState({ loader: false });
    }

    // Hourly duration steppers (parity with the client flow's estimatedHours). Never go below the
    // category minimum (pricingDetails.multiplierValue).
    addHours = async (data) => {
        const { orders } = this.state
        const { change } = this.props;
        this.setState({ loader: true });
        let ordersData = orders
        for (let obj of ordersData) {
            if (obj.subCategoryId == data.id) {
                const min = Number(obj.pricingDetails?.multiplierValue) || 1;
                obj.hours = (Number(obj.hours) > 0 ? Number(obj.hours) : min) + 1
            }
        }
        this.setState({ orders: ordersData });
        await change('orderData', ordersData);
        this.setState({ loader: false });
    }

    removeHours = async (data) => {
        const { orders } = this.state
        const { change } = this.props;
        this.setState({ loader: true });
        let ordersData = orders
        for (let obj of ordersData) {
            if (obj.subCategoryId == data.id) {
                const min = Number(obj.pricingDetails?.multiplierValue) || 1;
                obj.hours = Math.max(min, (Number(obj.hours) > 0 ? Number(obj.hours) : min) - 1)
            }
        }
        this.setState({ orders: ordersData });
        await change('orderData', ordersData);
        this.setState({ loader: false });
    }

    resetForm = () => {
        const { change } = this.props;
        this.setState({ orders: [] });
        change('orderData', []);
        change('isPreferredProvider', false);
        change('preferredPartnerId', null);
        change('preferredPartnerLat', null);
        change('preferredPartnerLng', null);
    }

    getSubCategories = () => {
        const { ordersData } = this.props;
        return ordersData?.map((order) => parseInt(order?.subCategoryId))
    }

    render() {
        const { subCategories, intl: { locale }, categoryId, ordersData, isPreferredProvider } = this.props;
        const { userId, lat, lng, updatingLocale, preferredProviders } = this.props;
        const { load, orders, loader } = this.state;
        const { Swiper, SwiperSlide } = this.swiperPackage;
        const { Navigation } = this.swiperModulesPackage;
        const rtl = isRTL(locale);

        const params = {
            slidesPerView: 1,
            spaceBetween: 12,
            modules: [Navigation],
            navigation: {
                nextEl: `.subCategorySwiperNavigationNextBtn`,
                prevEl: `.subCategorySwiperNavigationPrevBtn`,
            },
            breakpoints: {
                // when window width is >= 320px
                320: {
                    slidesPerView: 1,
                },
                // when window width is >= 575px
                575: {
                    slidesPerView: 2,
                },
                // when window width is >= 768px
                768: {
                    slidesPerView: 2,
                },
                // when window width is >= 992px
                992: {
                    slidesPerView: 3,
                },
                // when window width is >= 1200px
                1200: {
                    slidesPerView: 1,
                },
                // when window width is >= 1300px
                1300: {
                    slidesPerView: 2,
                },
                // when window width is >= 1300px
                1400: {
                    slidesPerView: 4,
                },
            }
        }

        return (
            <>
                <div className='commonSubCategorySliderContainer'>
                    {!isPreferredProvider && <div className={cx('subCategorySliderSpace')}><div className={cx('subCategorySliderBox')}>
                        {
                            !updatingLocale && load && subCategories?.length > 0 && <div className='swiperSliderRelativeContainer'>
                                <Swiper
                                    {...params}
                                    key={rtl} // force remount on language change
                                    dir={rtl ? 'rtl' : 'ltr'}>
                                    {
                                        subCategories.map((item, index) => {
                                            let existsData, orderQuantity;
                                            existsData = orders?.find(o => o.subCategoryId == item.id);
                                            orderQuantity = orders?.find(o => o.subCategoryId == item.id);

                                            return (
                                                <SwiperSlide>
                                                    <div key={index}>
                                                        <div className='subCategorySliderItemWrapper'>
                                                            <SubCategoryItem
                                                                id={item?.id}
                                                                image={item?.image}
                                                                name={item?.name}
                                                                description={item?.description}
                                                                pricingType={item?.categoryData?.pricingType}
                                                                pricingDetails={item?.pricingDetails}
                                                                currency={item?.currency}
                                                                categoryId={categoryId}
                                                                handleAddOrder={this.handleAddOrder}
                                                                existsItems={existsData ? true : false}
                                                                handleRemoveOrder={this.handleRemoveOrder}
                                                                quantity={orderQuantity?.quantity}
                                                                addOrderQuantity={this.addOrderQuantity}
                                                                removeOrderQuantity={this.removeOrderQuantity}
                                                                hours={orderQuantity?.hours}
                                                                addHours={this.addHours}
                                                                removeHours={this.removeHours}
                                                                categoryData={item?.categoryData}
                                                            />
                                                        </div>
                                                    </div>
                                                </SwiperSlide>
                                            );
                                        })}
                                </Swiper>
                                <ArrowButton
                                    className={cx('subCategorySwiperNavigationPrevBtn')}
                                    icon={prevIcon}
                                    alt="Previous"
                                />
                                <ArrowButton
                                    className={cx('subCategorySwiperNavigationNextBtn')}
                                    icon={nextIcon}
                                    alt="Next"
                                />
                            </div>
                        }
                    </div></div>}
                    {isPreferredProvider && <PreferredProviders
                        userId={userId}
                        subCategoryId={this.getSubCategories()}
                        lat={lat}
                        lng={lng}
                    />}
                </div>
                {((!isPreferredProvider && ordersData?.length > 0) || (isPreferredProvider && preferredProviders?.length > 0)) &&
                    <div className='commonSubCategoryPricingContainer'>
                        <PricingDetails
                            ordersDetails={ordersData}
                            subCategoryId={this.getSubCategories()}
                            loader={loader}
                            resetForm={this.resetForm}
                        />
                    </div>
                }
            </>
        )
    }
}

SubCategorySlider = reduxForm({
    form: 'ManualBookingForm',
    destroyOnUnmount: false
})(SubCategorySlider);

const selector = formValueSelector('ManualBookingForm');

const mapState = (state) => ({
    updatingLocale: state?.intl?.newLocale,
    subCategories: selector(state, 'subCategories'),
    categoryId: selector(state, 'categoryId'),
    isPreferredProvider: selector(state, 'isPreferredProvider'),
    preferredProviders: state?.booking?.preferredProviders,
    ordersData: selector(state, 'orderData'),
    userId: selector(state, 'userId'),
    lat: selector(state, 'lat'),
    lng: selector(state, 'lng'),
});
const mapDispatch = {
    change
}

export default injectIntl(withStyles(cs, s)(connect(mapState, mapDispatch)(SubCategorySlider)));
